import { render, staticRenderFns } from "./SetupCredentials.vue?vue&type=template&id=886f8e30&"
import script from "./SetupCredentials.vue?vue&type=script&lang=js&"
export * from "./SetupCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports